// extracted by mini-css-extract-plugin
export default {"linkWrapper":"S9DoNy","link":"R8yrlH","active":"xk44in"};